import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { INewsAdmin } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';

@Component({
  selector: 'app-news-admin',
  templateUrl: './news-admin.component.html',
  styleUrls: ['./news-admin.component.scss']
})
export class NewsAdminComponent implements OnInit {
  newsAdminGridView: GridDataResult;
  newsLoading: boolean;
  newsForm: FormGroup;
  saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  groupData: INewsAdmin[];
  categoryData: INewsAdmin[];
  subCategoryData: INewsAdmin[];
  selectedCategory: string = "";
  selectedCategoryId: string;
  selectedSubCategory: string;
  selectedSubCategoryId: string;
  newsImageUpload: string = "";
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf", ".docx", ".doc", ".html"],
  };
  constructor(private formBuilder: FormBuilder, private adminService: AdminService,
    private appNotifyService: AppNotifyService,
  ) { }

  ngOnInit() {
    this.loadNewsAdminGrid();
    this.newsForm = this.formBuilder.group({
      newsId: new FormControl(),
      group: new FormControl(),
      category: new FormControl(),
      subCategory: new FormControl(),
      fileUpload: new FormControl(),
      docDescription: new FormControl(),
      author: new FormControl(),
      mailNumber: new FormControl(),
      isActive: new FormControl(),
    })

  }
  loadNewsAdminGrid() {
    this.newsLoading = true;
    const body = {
      docTypeId: 18
    }
    this.adminService.getNewsAdminDetails(body).subscribe((response) => {
      this.bindNewsAdminGrid();
      this.newsLoading = false;
    });
  }
  //#region kendo upload 
  newsAdminSelected(evt: SelectEvent) {
  }
  newsAdminUploadSuccess(evt: SuccessEvent) {
    this.newsImageUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region label and variable declaration
  news = {
    groupLbl: "Group",
    categoryLbl: "Category",
    subCategoryLbl: "Sub Category",
    filePathLbl: "File Path",
    authorLbl: "Author",
    mailNoLbl: "Mail No.",
    isActiveLbl: "IsActive",
    uploadLbl: "Upload",
    closeLbl: "Close",
    saveLbl: "Save",
    addNewsLbl: "Add News",
    actionLbl: "Action",
    isSubmitted: false,
    isEmptyGroup: false,
    isEmptyCategory: false,
    isEmptySubCategory: false,
    isEmptyFile: false,
    isEmptyDescription: false,
    isEmptyAuthor: false,
    isEmptyMailNo: false
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public newsGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'newdId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindNewsAdminGrid(): void {
    const data = this.adminService.newsDetails;
    console.log(data);
    this.newsAdminGridView = process(data, this.newsGridstate);
  }

  public newsGridSortChange(sort: SortDescriptor[]): void {
    this.newsGridstate.sort = sort;
    this.bindNewsAdminGrid();
  }
  public newsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.newsGridstate.skip = skip;
    this.newsGridstate.take = take;
    this.bindNewsAdminGrid();
  }

  public newsDataStateChange(state: DataStateChangeEvent): void {
    this.newsGridstate = state;
    this.bindNewsAdminGrid();
  }
  //#endregion

  //#region news dialog operation

  newsDialog = {
    opened: false,
  }
  toggleNewsDialog() {
    this.newsDialog.opened = !this.newsDialog.opened;
    if (this.newsDialog.opened == true) {
      this.newsForm.controls.isActive.setValue(true);
      this.bindGroupDropdownData();
    } else {
      this.resetNewsForm();
    }
  }
  bindGroupDropdownData() {
    const data = this.adminService.newsDetails;
    if (data.length > 0) {
      let groupArray = data.filter((v, i, a) => a.findIndex(t => (t.docGroupingID === v.docGroupingID)) === i);
      this.groupData = groupArray as INewsAdmin[];
      //let filterArray = data.filter((v, i, a) => a.findIndex(t => (t.docCategoryID === v.docCategoryID)) === i);
      //this.categoryData = filterArray as INewsAdmin[];
      //let subCategoryArray = data.filter((v, i, a) => a.findIndex(t => (t.docSubCategoryID === v.docSubCategoryID)) === i);
      //this.subCategoryData = subCategoryArray as INewsAdmin[];

    }

  }

  groupChange(event) {
    let filterArray = this.adminService.newsDetails;
    let tempArray = filterArray.filter(f => f.docGroupingID == event.docGroupingID);
    tempArray = tempArray.filter((v, i, a) => a.findIndex(t => (t.docCategoryID === v.docCategoryID)) === i);
    this.categoryData = tempArray as INewsAdmin[];

  }
  categoryChange(event) {
    let filterArray = this.adminService.newsDetails;
    let tempArray = filterArray.filter(f => f.docCategoryID == event.docCategoryID);
    tempArray = tempArray.filter((v, i, a) => a.findIndex(t => (t.docSubCategoryID === v.docSubCategoryID)) === i);
    this.subCategoryData = tempArray as INewsAdmin[];

  }

  resetNewsForm() {
    this.newsForm.reset();
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.news.isSubmitted = false;
    this.news.isEmptyCategory = false;
    this.news.isEmptySubCategory = false;
    this.selectedCategory = "";
    this.selectedCategoryId = "";
    this.newsForm.controls.isActive.setValue(true);

    this.news.isEmptyGroup = false;
    this.news.isEmptyFile = false;
    this.news.isEmptyDescription = false;
    this.news.isEmptyAuthor = false;
    this.news.isEmptyMailNo = false;
    this.newsImageUpload = "";
  }

  validateNewsForm(): boolean {
    let isValid = true;
    const controls = this.newsForm.controls;
    if (this.news.isSubmitted) {
      const groupID = controls.group.value ? controls.group.value.docGroupingID : 0;
      if (groupID) {
        this.news.isEmptyGroup = false;
      } else {
        this.news.isEmptyGroup = true;
        isValid = false;
      }

      const categoryID = controls.category.value ? controls.category.value.docCategoryID : 0;
      if (categoryID) {
        this.news.isEmptyCategory = false;
      } else {
        this.news.isEmptyCategory = true;
        isValid = false;
      }

      const subCategoryID = controls.subCategory.value ? controls.subCategory.value.docSubCategoryID : 0;
      if (subCategoryID) {
        this.news.isEmptySubCategory = false;
      } else {
        this.news.isEmptySubCategory = true;
        isValid = false;
      }

      if (controls.docDescription.value) {
        this.news.isEmptyDescription = false;
      } else {
        this.news.isEmptyDescription = true;
        isValid = false;
      }

      if (controls.author.value) {
        this.news.isEmptyAuthor = false;
      } else {
        this.news.isEmptyAuthor = true;
        isValid = false;
      }

      if (controls.mailNumber.value) {
        this.news.isEmptyMailNo = false;
      } else {
        this.news.isEmptyMailNo = true;
        isValid = false;
      }

      //if (controls.fileUpload.value) {
      //  this.news.isEmptyFile = false;
      //} else {
      //  this.news.isEmptyFile = true;
      //  isValid = false;
      //}
    }
    return isValid;
  }

  updateNewsGridDetails(item) {
    this.adminService.updateNewsDetails(item).subscribe(response => {
      //this.bindNewsAdminGrid();
    })
  }
  //handleFileInput(files: FileList) {
  //  this.fileToUpload = files.item(0);
  //}
  public saveNewsDetails() {
    this.news.isSubmitted = true;
    if (!this.validateNewsForm()) {
      return;
    }
    var controls = this.newsForm.controls;
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    this.saveInProcess = true;
    const body = {
      DocId: 0,
      docTypeId: 18,
      DocGroupingId: controls.group ? controls.group.value.docGroupingID : 0,
      DocGroupingAlias: controls.group ? controls.group.value.docGroupingAlias : "",
      DocCategoryId: controls.category ? controls.category.value.docCategoryID : 0,
      docCategoryDesc: controls.category ? controls.category.value.docCategoryDesc : "",
      docSubCategoryId: controls.subCategory ? controls.subCategory.value.docSubCategoryID : 0,
      docSubCategoryDesc: controls.subCategory ? controls.subCategory.value.docSubCategoryDesc : "",
      //pathName: controls.fileUpload.value ? controls.fileUpload.value : "",
      pathName: this.newsImageUpload,
      docDesc: controls.docDescription.value ? controls.docDescription.value : "",
      partNo: controls.author.value ? controls.author.value : "", //saving author in partNo
      revision: controls.mailNumber.value ? controls.mailNumber.value : "", //saving mail number in revision 
      active: controls.isActive.value ? controls.isActive.value : false
    }

    //const formData = new FormData();
    //formData.append('DocId', body.DocId.toString());
    //formData.append('docTypeId', body.docTypeId.toString());
    //formData.append('DocGroupingId', body.DocGroupingId.toString());
    //formData.append('DocGroupingAlias', body.DocGroupingAlias);
    //formData.append('DocCategoryId', body.DocCategoryId);
    //formData.append('docCategoryDesc', body.docCategoryDesc);
    //formData.append('docSubCategoryId', body.docSubCategoryId);
    //formData.append('docSubCategoryDesc', body.docSubCategoryDesc);
    //formData.append('urlPath', body.pathName);
    //formData.append('docDesc', body.docDesc);
    //formData.append('partNo', body.partNo);
    //formData.append('revision', body.revision);
    //formData.append("active", controls.isActive.value ? controls.isActive.value : false);

    //if (this.fileToUpload != null) {
    //  formData.append('file', this.fileToUpload, this.fileToUpload ? this.fileToUpload.name : "");
    //}
    //else {
    //  formData.append('file', "");

    //}
    this.adminService.saveNewsDetails(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.resetNewsForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.bindNewsAdminGrid();
        //this.loadNewsAdminGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
    })
  }
  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete news ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.adminService.deleteNewsDetails(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const docID = this.gridItemToRemove.docID;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected news has been removed.");

      if (this.adminService.newsDetails) {
        //This is a Local Remove
        const index = (this.adminService.newsDetails).findIndex(r => r.docID === docID);
        (this.adminService.newsDetails).splice(index, 1);
        this.bindNewsAdminGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
